import { render, staticRenderFns } from "./DocumentConfigurationGeneration.vue?vue&type=template&id=2e813132&scoped=true"
import script from "./DocumentConfigurationGeneration.vue?vue&type=script&lang=js"
export * from "./DocumentConfigurationGeneration.vue?vue&type=script&lang=js"
import style0 from "./DocumentConfigurationGeneration.vue?vue&type=style&index=0&id=2e813132&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e813132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e813132')) {
      api.createRecord('2e813132', component.options)
    } else {
      api.reload('2e813132', component.options)
    }
    module.hot.accept("./DocumentConfigurationGeneration.vue?vue&type=template&id=2e813132&scoped=true", function () {
      api.rerender('2e813132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/documentConfiguration/components/DocumentConfigurationGeneration.vue"
export default component.exports